/**
 * Fehler aus dem Server-Render tragen in Next.js einen `digest`. Sie sind ueber `onRequestError`
 * (instrumentation.ts) bereits serverseitig mit Stacktrace an Sentry gemeldet. Meldet das
 * Error-Boundary sie auf dem Client erneut, entsteht ein zweites Issue ohne Stacktrace und mit
 * der Produktions-Platzhaltermeldung (STELLENPORTAL-1C neben STELLENPORTAL-19).
 */
export const wasReportedOnServer = (error: Error & { digest?: string }): boolean =>
  typeof error.digest === 'string' && error.digest.length > 0;
